import { createStyles, makeStyles, Theme } from '@material-ui/core'
import { ThemeConstants } from '../../styles'

export default makeStyles((theme: Theme) =>
  createStyles({
    disclaimer: {
      paddingBottom: theme.spacing(4),
      paddingTop: theme.spacing(ThemeConstants.BASE_SPACING),
    },
    viewContainer: {
      paddingBottom: theme.spacing(ThemeConstants.BASE_SPACING),
      paddingTop: theme.spacing(ThemeConstants.BASE_SPACING),
    },
  })
)
